(() => {
  if (!document.body.classList.contains('snug-complete-set-product')) return;
  const positionChat = () => {
    const chat = document.querySelector('shopify-chat');
    const runtime = chat?.shadowRoot?.querySelector('shopify-agent-runtime');
    const root = runtime?.shadowRoot;
    if (!root) return false;
    if (!root.getElementById('snug-set-chat-clearance')) {
      const style = document.createElement('style');
      style.id = 'snug-set-chat-clearance';
      style.textContent = "@media (max-width: 768px) {\n  .activator-nudge {\n    right: 14px !important;\n    left: auto !important;\n    bottom: 8px !important;\n  }\n  .activator {\n    width: 48px !important;\n    min-width: 48px !important;\n    height: 48px !important;\n    padding: 0 !important;\n    border-radius: 14px !important;\n    justify-content: center !important;\n    background: #293f98 !important;\n    color: #fff !important;\n  }\n  .activator__label { display: none !important; }\n}";
      root.appendChild(style);
    }
    return true;
  };
  if (positionChat()) return;
  let attempts = 0;
  const timer = window.setInterval(() => {
    if (positionChat() || ++attempts >= 80) window.clearInterval(timer);
  }, 250);
})();
